
import { z } from "zod";

export const ProjectCategoryValues = ["ASSESSMENT", "BACKFILL", "BID", "CORRECTIONS", "ESTIMATE_ONLY", "FULL_ROOF", "GUTTERS", "LIVE_VISIT", "MISC", "PARTIAL_ROOF", "QA", "REINSTALL", "REMOVAL", "RFR", "SIDING", "SITE_VISIT", "SOLAR_REDESIGN", "STRUCTURAL", "VENT_WORK"] as const;
export const ProjectCategorySchema = /* @__PURE__ */ z.enum(ProjectCategoryValues);
export const ProjectCategory: (typeof ProjectCategorySchema)["enum"] = { "ASSESSMENT": "ASSESSMENT", "BACKFILL": "BACKFILL", "BID": "BID", "CORRECTIONS": "CORRECTIONS", "ESTIMATE_ONLY": "ESTIMATE_ONLY", "FULL_ROOF": "FULL_ROOF", "GUTTERS": "GUTTERS", "LIVE_VISIT": "LIVE_VISIT", "MISC": "MISC", "PARTIAL_ROOF": "PARTIAL_ROOF", "QA": "QA", "REINSTALL": "REINSTALL", "REMOVAL": "REMOVAL", "RFR": "RFR", "SIDING": "SIDING", "SITE_VISIT": "SITE_VISIT", "SOLAR_REDESIGN": "SOLAR_REDESIGN", "STRUCTURAL": "STRUCTURAL", "VENT_WORK": "VENT_WORK" };
export type ProjectCategory = (typeof ProjectCategoryValues)[number];
export const ProjectCategoryDisplayNames = { "ASSESSMENT": "Assessment",
"BACKFILL": "Backfill",
"BID": "Bid",
"CORRECTIONS": "Corrections",
"ESTIMATE_ONLY": "Estimate only",
"FULL_ROOF": "Full roof",
"GUTTERS": "Gutters",
"LIVE_VISIT": "Live visit",
"MISC": "Miscellaneous",
"PARTIAL_ROOF": "Partial roof",
"QA": "QA",
"REINSTALL": "Reinstall",
"REMOVAL": "Removal",
"RFR": "RFR",
"SIDING": "Siding",
"SITE_VISIT": "Site visit",
"SOLAR_REDESIGN": "Solar redesign",
"STRUCTURAL": "Structural",
"VENT_WORK": "Vent work", } satisfies Record<ProjectCategory, string>;
